import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
    const [user, setUser] = useState(undefined);

    useEffect(() => {
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(null));
    }, []);

    const login = useCallback(async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data);
            toast.success(`Halo, ${data.name}!`);
            return true;
        } catch (e) {
            toast.error(formatApiErrorDetail(e.response?.data?.detail));
            return false;
        }
    }, []);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {
            /* ignore */
        }
        setUser(null);
        toast.info("Kamu sudah logout.");
    }, []);

    return (
        <AppContext.Provider value={{ user, setUser, login, logout }}>
            {children}
        </AppContext.Provider>
    );
}
